import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../ui/utils';
import { PageBackButton } from './PageBackButton';

type PageHeaderProps = HTMLAttributes<HTMLElement> & {
    icon?: ReactNode;
    title: string;
    description?: string;
    actions?: ReactNode;
    backHref?: string;
    onBack?: () => void;
    backLabel?: string;
};

function PageHeader({
    icon,
    title,
    description,
    actions,
    backHref,
    onBack,
    backLabel,
    className,
    ...props
}: PageHeaderProps) {
    const showBack = Boolean(backHref || onBack);

    return (
        <section className={cn('nx-page-toolbar', className)} {...props}>
            <div className="nx-page-heading">
                {showBack ? (
                    <PageBackButton
                        href={backHref}
                        label={backLabel}
                        onClick={onBack}
                    />
                ) : null}
                {icon ? (
                    <div className="nx-page-icon" aria-hidden>
                        {icon}
                    </div>
                ) : null}
                <div>
                    <h1>{title}</h1>
                    {description ? <p>{description}</p> : null}
                </div>
            </div>
            {actions ? <div className="nx-page-actions">{actions}</div> : null}
        </section>
    );
}

export { PageHeader };
export type { PageHeaderProps };
